import { c as _c } from "react/compiler-runtime";
import { Separator, Heading, HStack, Image, SimpleGrid, VStack, Text } from '@chakra-ui/react';
import { SuccessStats } from '@src/components/sco/SuccessLP/SuccessStats';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
export const CustomerSuccessBlock: React.FC = () => {
  const $ = _c(54);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const isMobile = getBreakpointValue([true, true, false, false, false]);
  const t0 = isMobile ? "xl" : "3xl";
  let t1;
  if ($[0] !== getBreakpointValue) {
    t1 = getBreakpointValue([10]);
    $[0] = getBreakpointValue;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== getBreakpointValue) {
    t2 = getBreakpointValue([4, 4, 10, 10, 10]);
    $[2] = getBreakpointValue;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Separator flex="1" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== getBreakpointValue) {
    t4 = getBreakpointValue(["xl", "2xl", "3xl"]);
    $[5] = getBreakpointValue;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <Text color="blue.fg" flexShrink="0" fontSize={t4} fontWeight={700} letterSpacing="wide" textAlign="center" textStyle="heading" textTransform="uppercase">Customer Success</Text>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Separator flex="1" />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5) {
    t7 = <HStack align="center" gap={10} justify="center" width="full">{t3}{t5}{t6}</HStack>;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== getBreakpointValue) {
    t8 = getBreakpointValue(["3xl", "4xl", "5xl", "6xl"]);
    $[12] = getBreakpointValue;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <Heading color="red.fg" fontWeight={700} size={t8} textAlign="center">Our success is 100% measured by the startups on our platform</Heading>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <SuccessStats />;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const t11 = isMobile ? 0 : 6;
  let t12;
  if ($[17] !== t11) {
    t12 = <Separator marginY={t11} width="full" />;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  const t13 = isMobile ? 3 : 6;
  let t14;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      _light: "invert(1)",
      _dark: "invert(0)"
    };
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = require("@public/assets/graphics/client-logos/instacart-logo.svg");
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  const t16 = isMobile ? "50px" : "100px";
  let t17;
  if ($[21] !== t16) {
    t17 = <Image alt="Instacart" objectFit="contain" src={t15.default.src} width={t16} />;
    $[21] = t16;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = require("@public/assets/graphics/client-logos/bumble-logo.svg");
    $[23] = t18;
  } else {
    t18 = $[23];
  }
  const t19 = isMobile ? "50px" : "100px";
  let t20;
  if ($[24] !== t19) {
    t20 = <Image alt="Bumble" objectFit="contain" src={t18.default.src} width={t19} />;
    $[24] = t19;
    $[25] = t20;
  } else {
    t20 = $[25];
  }
  let t21;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = require("@public/assets/graphics/client-logos/vevo-logo.svg");
    $[26] = t21;
  } else {
    t21 = $[26];
  }
  const t22 = isMobile ? "50px" : "100px";
  let t23;
  if ($[27] !== t22) {
    t23 = <Image alt="Vevo" objectFit="contain" src={t21.default.src} width={t22} />;
    $[27] = t22;
    $[28] = t23;
  } else {
    t23 = $[28];
  }
  let t24;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = require("@public/assets/graphics/client-logos/hoteltonight-logo.svg");
    $[29] = t24;
  } else {
    t24 = $[29];
  }
  const t25 = isMobile ? "50px" : "100px";
  let t26;
  if ($[30] !== t25) {
    t26 = <Image alt="HotelTonight" objectFit="contain" src={t24.default.src} width={t25} />;
    $[30] = t25;
    $[31] = t26;
  } else {
    t26 = $[31];
  }
  let t27;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = require("@public/assets/graphics/chomps-logo.svg");
    $[32] = t27;
  } else {
    t27 = $[32];
  }
  const t28 = isMobile ? "50px" : "100px";
  let t29;
  if ($[33] !== t28) {
    t29 = <Image alt="Chomps" objectFit="contain" src={t27.default.src} width={t28} />;
    $[33] = t28;
    $[34] = t29;
  } else {
    t29 = $[34];
  }
  let t30;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = require("@public/assets/graphics/client-logos/ag1-logo.svg");
    $[35] = t30;
  } else {
    t30 = $[35];
  }
  const t31 = isMobile ? "50px" : "100px";
  let t32;
  if ($[36] !== t31) {
    t32 = <Image alt="Athletic Greens" objectFit="contain" src={t30.default.src} width={t31} />;
    $[36] = t31;
    $[37] = t32;
  } else {
    t32 = $[37];
  }
  let t33;
  if ($[38] !== t13 || $[39] !== t17 || $[40] !== t20 || $[41] !== t23 || $[42] !== t26 || $[43] !== t29 || $[44] !== t32) {
    t33 = <SimpleGrid alignItems="center" columns={t13} filter={t14} gap={4} justifyItems="center" width="full">{t17}{t20}{t23}{t26}{t29}{t32}</SimpleGrid>;
    $[38] = t13;
    $[39] = t17;
    $[40] = t20;
    $[41] = t23;
    $[42] = t26;
    $[43] = t29;
    $[44] = t32;
    $[45] = t33;
  } else {
    t33 = $[45];
  }
  let t34;
  if ($[46] !== t0 || $[47] !== t1 || $[48] !== t12 || $[49] !== t2 || $[50] !== t33 || $[51] !== t7 || $[52] !== t9) {
    t34 = <VStack align="center" borderRadius={t0} gap={t1} height="full" justify="stretch" overflow="hidden" padding={t2} width="full" boxShadow="inset 0 1px 0 rgba(255, 255, 255, 0.2)" bgImage="linear-gradient({colors.blue.muted}, transparent, transparent, {colors.blue.muted})">{t7}{t9}{t10}{t12}{t33}</VStack>;
    $[46] = t0;
    $[47] = t1;
    $[48] = t12;
    $[49] = t2;
    $[50] = t33;
    $[51] = t7;
    $[52] = t9;
    $[53] = t34;
  } else {
    t34 = $[53];
  }
  return t34;
};